<template>
   <KTCodePreview v-bind:title="formTitle"
    > <template v-slot:toolbar
      >
      <div
        class="row"
        v-if="stockSlip.id"
      >

        <div>
           <b-row
            class="mb-4 ml-4"
            style="vertical-align: middle; display: inline"
            > <EditToggle
              v-if="stockSlip.id && !isViewOnly"
              v-model="isEdit"
              id="customSwitch2"
              label="Chỉnh sửa"
            /> </b-row
          >
        </div>

      </div>
       </template
    > <template v-slot:preview
      > <b-row
        class="col-md-12 mb-1 m-0 p-0"
        v-if="purchaseOrderId"
        >
        <div
          class="alert-header"
          style="width: 100%"
        >
           Tạo phiếu nhập từ phiếu yêu cầu nhập hàng: <span
            class="text-primary orderCode"
            @click="linkToPO(purchaseOrderCode)"
            style="cursor: pointer"
            >{{ purchaseOrderCode }}</span
          >
        </div>
         </b-row
      > <b-row
        class="col-md-12 mb-3 m-0 p-0"
        v-if="isViewOnly && stockSlip.billId"
        >
        <div
          class="alert alert-light border w-100 mb-0"
        >
          Phiếu tạo tự động từ chứng từ:
          <a
            class="text-primary font-weight-bold cursor-pointer"
            @click="linkToSourceDocument"
            >#{{ stockSlip.billId }}</a
          >
        </div>
         </b-row
      > <b-row class="col-md-12 mb-1 m-0 p-0"
        > <StockSlipSkeleton
          :renderComponent="renderComponent"
          v-if="!renderComponent"
        /> </b-row
      >
      <div v-if="renderComponent">
         <b-tabs
          v-if="stockSlip.id"
          v-model="activeTab"
          content-class="mt-3"
          > <b-tab title="Thông tin"
            > <StockSlipImportExportBody
              :stock-slip="stockSlip"
              :stock-slip-options="stockSlipOptions"
              :stores="filteredOptions"
              :providers="providerOptions"
              :editable="isEdit"
              :in-stock="false"
              @onSelectedStore="onSelectedStore"
              @onInputChangeStore="onInputChangeStore"
              @onSelectedProvider="onSelectedProvider"
              @onInputChangeProvider="onInputChangeProvider"
              @onFetchProvider="fetchProvider"
            /> </b-tab
          > <b-tab title="Lịch sử"> <StockSlipHistoryTab :stock-slip-id="stockSlip.id" /> </b-tab>
          </b-tabs
        > <StockSlipImportExportBody
          v-else
          :stock-slip="stockSlip"
          :stock-slip-options="stockSlipOptions"
          :stores="filteredOptions"
          :providers="providerOptions"
          :editable="isEdit"
          :in-stock="false"
          @onSelectedStore="onSelectedStore"
          @onInputChangeStore="onInputChangeStore"
          @onSelectedProvider="onSelectedProvider"
          @onInputChangeProvider="onInputChangeProvider"
          @onFetchProvider="fetchProvider"
        />
      </div>
       </template
    > <template v-slot:foot
      > <b-button
        v-if="!isViewOnly"
        style="font-weight: 600; width: 70px"
        variant="primary"
        size="sm"
        @click="onSubmit"
        :disabled="!isEdit"
        >Lưu</b-button
      > <router-link
        :to="listBasePath"
        tag="button"
        > <b-button
          style="margin-left: 10px; font-weight: 600; width: 70px"
          variant="secondary"
          size="sm"
          >Hủy</b-button
        > </router-link
      > </template
    > </KTCodePreview
  >
</template>

<script>
  import apiCommonMixin from '@/view/mixins/api-common.mixins.js'
  import providerSearchMixin from '@/view/mixins/provider-search.mixin.js'
  import ApiService from '@/core/services/api.service'
  import moment from 'moment'
  import { STOCK_SLIP_TYPE } from '@/utils/enum'
  import KTCodePreview from '@/view/content/CodePreview.vue'
  import { makeToastFaile, makeToastSuccess, roundBeforeVatFromUnitPrice, xoa_dau } from '@/utils/common'
  import StockSlipSkeleton from '../../../components/stock-slips/StockSlipSkeleton.vue'
  import EditToggle from '@/view/components/common/EditToggle.vue'
  import StockSlipHistoryTab from '@/view/components/stock-slips/StockSlipHistoryTab.vue'
  import StockSlipImportExportBody from '@/view/components/stock-slips/StockSlipImportExportBody.vue'
  import {
    AUTO_STOCK_SLIP_LABELS,
    isAutoBillDrivenStockSlipType,
    isStockSlipViewOnly,
    STOCK_SLIP_LIST_MODE,
  } from '@/utils/stockSlipOrigin'
  import { openImeiHistoryDocument } from '@/utils/imeiHistoryDocument'

  export default {
    mixins: [apiCommonMixin, providerSearchMixin],
    data() {
      return {
        stockSlip: {
          id: null,
          code: '',
          type: 1,
          slipType: null,
          billId: null,
          stockSlipDate: moment().format('DD-MM-YYYY'),
          storeName: '',
          storeId: null,
          providerName: '',
          providerId: null,
          subProviderId: null,
          subProviderName: '',
          discountType: 1,
          discountAmount: 0,
          vatType: 1,
          vatAmount: 0,
          vatCode: '',
          vatDate: '',
          notes: '',
          details: [],
        },
        stockSlipOptions: [
          { value: STOCK_SLIP_TYPE.IMPORT_PROVIDER, text: 'Nhập kho NCC' },
          {
            value: STOCK_SLIP_TYPE.IMPORT_HKD,
            text: 'Nhập kho HKD',
          },
        ],
        filteredOptions: [],
        stores: [],
        isSubmitting: false,
        renderComponent: true,
        isEdit: false,
        isViewOnly: false,
        activeTab: 0,
        purchaseOrderId: null,
        purchaseOrderCode: null,
      }
    },
    components: {
      KTCodePreview,
      StockSlipSkeleton,
      EditToggle,
      StockSlipHistoryTab,
      StockSlipImportExportBody,
    },
    computed: {
      isAutoFormPage() {
        return this.$route.meta.stockSlipListMode === STOCK_SLIP_LIST_MODE.AUTO
      },
      listBasePath() {
        return this.isAutoFormPage ? '/inventory-receipt-auto' : '/inventory-receipt'
      },
      formTitle() {
        if (this.isViewOnly && this.isAutoFormPage) {
          return AUTO_STOCK_SLIP_LABELS.DETAIL_IMPORT
        }
        return this.stockSlip.id ? 'Thông tin phiếu nhập kho' : 'Thêm mới phiếu nhập kho'
      },
    },
    async created() {
      this.filteredOptions = []
      const { stores, currentStoreId, currentStoreName } = await this.fetchStoreByUser()
      this.stores = stores
      this.filteredOptions = [...this.stores]
      if (currentStoreId && !this.stockSlip.storeId) {
        this.stockSlip.storeId = currentStoreId
        this.stockSlip.storeName = currentStoreName
      }
      this.stockSlip.id = this.$route.query?.id || null
      if (this.$route.name === 'view-inventory-receipt-auto') {
        this.isViewOnly = true
      }
      if (this.stockSlip.id) {
        await this.getStockSlipByID()
      } else {
        this.isEdit = true
      }
    },
    mounted() {
      if (this.$route.query.purchaseOrderId) {
        this.purchaseOrderId = this.$route.query.purchaseOrderId
        this.getPOInfoById()
      }
    },
    methods: {
      fetchProvider() {
        // No-op: provider search được xử lý bởi Autosuggest (server-side search)
      },
      createStockSlip: async function () {
        const details = this.stockSlip.details.map((element) => {
          const imeis = element.IMEI?.trim() || ''
          return {
            productId: element.productId,
            imeis,
            quantity: element.quantity,
            unitPrice: element.productPriceMask || 0,
            afterVatPrice:
              element.afterVatPriceMask != null
                ? element.afterVatPriceMask
                : element.productPriceMask || 0,
            discount: element.discountAmount || 0,
            vatAmount: element.vatAmount || 0,
          }
        })
        const payload = {
          sourceWarehouseId: this.stockSlip.storeId,
          providerId: this.stockSlip.providerId,
          subProviderId: this.stockSlip.subProviderId,
          stockSlipDate: this.stockSlip.stockSlipDate
            ? moment(this.stockSlip.stockSlipDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
            : null,
          vatDate: this.stockSlip.vatDate
            ? moment(this.stockSlip.vatDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
            : null,
          vatType: this.stockSlip.vatType,
          vatAmount: this.stockSlip.vatAmount ? this.stockSlip.vatAmount : 0,
          vatCode: this.stockSlip.vatCode,
          vatSerial: this.stockSlip.vatSerial,
          discountType: this.stockSlip.discountType,
          discountAmount: this.stockSlip.discountAmount ? this.stockSlip.discountAmount : 0,
          description: this.stockSlip.notes,
          stockSlipType: STOCK_SLIP_TYPE.IMPORT_PROVIDER,
          hasVat: this.stockSlip.type === STOCK_SLIP_TYPE.IMPORT_HKD ? false : true,
          purchaseOrderId: this.purchaseOrderId,
          purchaseOrderCode: this.purchaseOrderCode,
          details,
        }

        try {
          const res = await ApiService.post('v1/stock-slips', payload).catch((error) => {
            this.isSubmitting = false
            const message = error?.response?.data?.message || 'Lỗi!'
            makeToastFaile(message)
          })
          makeToastSuccess(res.data.message)
          this.$router.push({
            name: 'list-inventory-receipt',
          })
        } catch ({ response }) {
          makeToastFaile(response.$error)
        } finally {
          this.isSubmitting = false
        }
      },
      updateStockSlip: async function () {
        const details = this.stockSlip.details.map((element) => {
          const imeis = element.IMEI?.trim() || ''
          return {
            id: element.id,
            productId: element.productId,
            imeis,
            quantity: element.quantity,
            unitPrice: element.productPriceMask || 0,
            afterVatPrice:
              element.afterVatPriceMask != null
                ? element.afterVatPriceMask
                : element.productPriceMask || 0,
            discount: element.discountAmount || 0,
            vatAmount: element.vatAmount || 0,
          }
        })
        const payload = {
          id: this.stockSlip.id,
          sourceWarehouseId: this.stockSlip.storeId,
          providerId: this.stockSlip.providerId,
          subProviderId: this.stockSlip.subProviderId,
          stockSlipDate: this.stockSlip.stockSlipDate
            ? moment(this.stockSlip.stockSlipDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
            : null,
          description: this.stockSlip.notes,
          vatDate: this.stockSlip.vatDate
            ? moment(this.stockSlip.vatDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
            : null,
          vatType: this.stockSlip.vatType,
          vatAmount: this.stockSlip.vatAmount ? this.stockSlip.vatAmount : 0,
          vatCode: this.stockSlip.vatCode,
          vatSerial: this.stockSlip.vatSerial,
          discountType: this.stockSlip.discountType,
          discountAmount: this.stockSlip.discountAmount ? this.stockSlip.discountAmount : 0,
          stockSlipType: STOCK_SLIP_TYPE.IMPORT_PROVIDER,
          hasVat: this.stockSlip.type === STOCK_SLIP_TYPE.IMPORT_HKD ? false : true,
          details,
        }
        try {
          const res = await ApiService.put('v1/stock-slips', payload).catch((error) => {
            this.isSubmitting = false
            const message = error?.response?.data?.message || 'Lỗi!'
            makeToastFaile(message)
          })
          makeToastSuccess(res.data.message)
          this.$router.push({
            name: 'list-inventory-receipt',
          })
        } catch ({ response }) {
          makeToastFaile(response.$error)
        } finally {
          this.isSubmitting = false
        }
      },
      onSubmit() {
        if (this.isSubmitting) return
        this.isSubmitting = true
        if (!this.stockSlip.id) {
          this.createStockSlip()
          return
        }
        this.updateStockSlip()
      },
      onSelectedStore(option) {
        this.stockSlip.storeName = option.item.name
        this.stockSlip.storeId = option.item.id
      },
      onInputChangeStore(text) {
        this.stockSlip.storeName = text
        const filteredData = this.stores
          .filter((item) => {
            return (
              xoa_dau(item.name).toLowerCase().indexOf(text.toLowerCase()) > -1 ||
              item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
            )
          })
          .slice(0, 10)
        this.filteredOptions = [...filteredData]
      },
      onSelectedProvider(option) {
        this.stockSlip.providerName = option.item.fullName
        this.stockSlip.providerId = option.item.id
        this.stockSlip.subProviderId = null
        this.stockSlip.subProviderName = ''
      },
      linkToSourceDocument() {
        openImeiHistoryDocument(this.$router, {
          type: this.stockSlip.slipType,
          billId: this.stockSlip.billId,
          stockSlipId: this.stockSlip.id,
        })
      },
      getStockSlipByID: async function () {
        this.renderComponent = false
        ApiService.get(`v1/stock-slips/${this.stockSlip.id}`).then((data) => {
          const stockSlipData = data.data.data
          this.stockSlip.slipType = stockSlipData.type
          this.stockSlip.billId = stockSlipData.billId
          this.isViewOnly =
            this.$route.query.viewOnly === '1' || isStockSlipViewOnly(stockSlipData.type)
          this.isEdit = false
          this.stockSlip.code = stockSlipData.code
          if (isAutoBillDrivenStockSlipType(stockSlipData.type)) {
            this.stockSlip.type = stockSlipData.type
          } else {
            this.stockSlip.type = stockSlipData.hasVat
              ? STOCK_SLIP_TYPE.IMPORT_PROVIDER
              : STOCK_SLIP_TYPE.IMPORT_HKD
          }
          this.stockSlip.storeId = stockSlipData.storeId
          this.stockSlip.storeName = stockSlipData.storeName
          this.stockSlip.providerId = stockSlipData.providerId
          // Phase 4: BE trả về providerName đã dùng Customer.fullName
          this.stockSlip.providerName = stockSlipData.providerName
          this.stockSlip.stockSlipDate = stockSlipData.stockSlipDate
            ? moment(stockSlipData.stockSlipDate).format('DD-MM-YYYY')
            : ''
          this.stockSlip.discountType = stockSlipData.discountType
          this.stockSlip.discountAmount = stockSlipData.discountAmount
          this.stockSlip.vatAmount = stockSlipData.vatAmount ? stockSlipData.vatAmount : 0
          this.stockSlip.vatType = stockSlipData.vatType ? stockSlipData.vatType : 2
          this.stockSlip.vatCode = stockSlipData.vatCode ? stockSlipData.vatCode : ''
          this.stockSlip.vatSerial = stockSlipData.vatSerial ? stockSlipData.vatSerial : ''
          this.stockSlip.vatDate = stockSlipData.vatDate
            ? moment(stockSlipData.vatDate).format('DD-MM-YYYY')
            : ''
          this.stockSlip.notes = stockSlipData.description
          this.stockSlip.details = stockSlipData.details.map((detail, index) => {
            const afterVatPrice = detail.afterVatPrice ?? detail.unitPrice
            return {
              ...detail,
              stt: index + 1,
              productPriceMask:
                detail.beforeVatPrice ??
                roundBeforeVatFromUnitPrice(afterVatPrice, detail.vatAmount),
              afterVatPriceMask: afterVatPrice,
              IMEI: detail.productImei || '',
            }
          })
          this.stockSlip.subProviderId = stockSlipData.subProviderId || null
          this.stockSlip.subProviderName = stockSlipData.subProviderName || ''
          this.purchaseOrderId = stockSlipData.purchaseOrderId
          this.purchaseOrderCode = stockSlipData.purchaseOrderCode
          this.renderComponent = true
        })
      },
      getPOInfoById() {
        ApiService.get(`v1/purchase-orders/${this.purchaseOrderId}`)
          .then(({ data }) => {
            this.purchaseOrderCode = data.data.code ? data.data.code : ''
            this.stockSlip.notes = data.data.description ? data.data.description : ''
            this.stockSlip.storeName = data.data.storeName ? data.data.storeName : ''
            this.stockSlip.storeId = data.data.storeId
            this.stockSlip.providerName = data.data.providerName ? data.data.providerName : ''
            this.stockSlip.providerId = data.data.providerId
            this.stockSlip.subProviderId = data.data.subProviderId
            this.stockSlip.subProviderName = data.data.subProviderName
            this.stockSlip.discountType = data.data.discountType
            this.stockSlip.discountAmount = data.data.discountAmount
            this.stockSlip.vatAmount = data.data.vatAmount ? data.data.vatAmount : 0
            this.stockSlip.vatType = data.data.vatType ? data.data.vatType : 2
            this.stockSlip.vatCode = data.data.vatCode ? data.data.vatCode : ''
            this.stockSlip.vatDate = data.data.vatDate
              ? moment(data.data.vatDate).format('DD-MM-YYYY')
              : ''
            this.stockSlip.details = data.data.details.map((element, index) => {
              const totalAmount = element.quantity * element.unitPrice - element.discountAmount
              return {
                stt: index + 1,
                totalAmount: totalAmount,
                id: element.id,
                IMEI: '',
                productId: element.productId,
                productPriceMask: element.beforeVatPrice,
                afterVatPriceMask: element.unitPrice,
                vatAmount: element.vatAmount,
                quantity: element.quantityApprove,
                productType: element.productType,
                inStockQuantity: element.inStockQuantity,
                discountAmount: element.discountAmount ? element.discountAmount : 0,
                productName: element.productName,
                barCode: element.barCode ? element.barCode : '',
                productCode: element.productCode ? element.productCode : '',
                productImageUrl: element.productImageUrl ? element.productImageUrl : '',
              }
            })
          })
          .catch((response) => {
            console.log('response: ', response)
            makeToastFaile(response)
          })
      },
      linkToPO: function (poCode) {
        const { href } = this.$router.resolve({
          name: 'info-purchase-orders',
          query: { id: poCode },
        })
        window.open(href, '_blank')
      },
    },
  }
</script>

<style lang="scss" scoped>
  .alert-header {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}
.orderCode:hover {
  text-decoration: underline;
}
</style>

